import React from "react";
// import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";

import { Grid, FormControl, InputLabel } from "@material-ui/core";

import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker";
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  input: {
    marginTop: "0 !important",
  },
  nb: {
    color: "red",
    fontSize: "12px",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "67%",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  searchButton: {
    backgroundColor: " #66bb6a",
  },
  airlineSelect: {
    marginTop: "0px",
    width: "100%",
  },
});

function PdmPanel(props) {
  const {
    classes,
    airlineData,
    searchFlightNumbers,
    selectChange,
    startDate,
    endDate,
    handleDateChange,
    onSearch,
    searchLocationData,
    searchDestinationData,
    user,
    statusTypes,
    searchLocationId,
    // serviceTypes,
    // serviceType
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item xs={3}>
          <div className="picker">
            <InlineDatePicker
              Date={startDate}
              handleDateChange={(date) => handleDateChange(date, "startDate")}
              label="Start Date"
            />
          </div>
        </Grid>
        <Grid item xs={3}>
          <div className="picker">
            <InlineDatePicker
              Date={endDate}
              handleDateChange={(date) => handleDateChange(date, "endDate")}
              label="End Date"
            />
          </div>
        </Grid>

        <Grid item xs={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
              options={airlineData.map((option) => ({
                value: option.AirlineId,
                label: option.Airline,
              }))}
              name={"AirlineId"}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Flight Number
            </InputLabel>
            <AutocompleteSelect
              options={searchFlightNumbers.map((option) => ({
                value: option.FlightNumber,
                label: option.FlightNumber,
              }))}
              name={"searchFlightNumber"}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="airlineId">
              Departure Location
            </InputLabel>
            <AutocompleteSelect
              options={searchLocationData.map((option) => ({
                value: option.Code,
                label: option.Name,
              }))}
              name={"searchLocationId"}
              handleSelectChange={(e, name) => selectChange(e, name)}
              disabled={
                user.AppRole === appConstants.ROLES.AIRPORT_MANAGER ||
                user.Location
              }
              selectedOption={searchLocationId}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="airlineId">
              Destination
            </InputLabel>
            <AutocompleteSelect
              options={searchDestinationData.map((option) => ({
                value: option.Code,
                label: option.Name,
              }))}
              name={"searchDestinationId"}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Status
            </InputLabel>
            <AutocompleteSelect
              options={statusTypes.map((option) => ({
                value: option.value,
                label: option.name,
              }))}
              name={"Status"}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
          </FormControl>
        </Grid>
        {/* <Grid item xs={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Service Type
            </InputLabel>
            <AutocompleteSelect
              options={serviceTypes.map((option) => ({
                value: option.Id,
                label: option.Name,
              }))}
              name={"serviceType"}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectedOption={serviceType}
            />
          </FormControl>
        </Grid> */}
        <Grid item xs={3}>
          <Button color="regional" onClick={() => onSearch()}>
            Search
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(PdmPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/PDM/PdmPanel.jsx